import * as React from "react"

//https://react-svgr.com/playground/
function SvgIconCuidadoPersonalOn(props) {
    return (
        <svg
            width={246}
            height={246}
            viewBox="0 0 246 246"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
            d="M183.244 35.144c0-10.724 8.716-19.408 19.434-19.408 10.728 0 19.415 8.684 19.415 19.408 0 10.705-8.687 19.408-19.415 19.408-10.708.01-19.434-8.694-19.434-19.408z"
            fill="#000"
            />
            <path
            d="M171.686 61.885c-.01 3.071-2.712 5.712-5.765 5.642-3.002-.07-5.564-2.68-5.544-5.672.01-3.061 2.712-5.702 5.765-5.632 3.012.06 5.554 2.67 5.544 5.662zm-2.732-.1a2.923 2.923 0 00-5.845.09 2.903 2.903 0 002.962 2.921 2.924 2.924 0 002.883-3.011zM184.635 54.692c-.02 2.261-2.031 4.232-4.283 4.182-2.262-.05-4.213-2.091-4.133-4.332.08-2.2 2.001-4.082 4.193-4.092 2.262 0 4.233 1.981 4.223 4.242z"
            fill="#FFDD00"
            stroke="#FFDD00"
            strokeMiterlimit={10}
            />
            <path
            d="M60.074 79.062h8.456v2.841c-.83.05-1.641.1-2.582.15v2.551c.83.07 1.702.13 2.642.21v5.653h-8.516V79.062z"
            fill="#FFDD00"
            />
            <circle cx={123} cy={123} r={117} fill="#000" />
            <path
            d="M123.01 245.92C55.18 245.92 0 190.767 0 122.96 0 55.162 55.18 0 123.01 0 190.83 0 246 55.162 246 122.97c0 67.807-55.17 122.95-122.99 122.95zm0-239.047C58.973 6.873 6.875 58.953 6.875 122.97c0 64.016 52.098 116.077 116.135 116.077 64.017 0 116.115-52.071 116.115-116.077S187.027 6.873 123.01 6.873z"
            fill="#000"
            />
            <path
            d="M192.211 35.144c0-5.782 4.673-10.444 10.467-10.444a10.43 10.43 0 0110.458 10.444 10.437 10.437 0 01-10.458 10.444c-5.794 0-10.467-4.681-10.467-10.444z"
            fill="#FFDD00"
            />
            <path
            d="M74.244 107.774c1.582 0 2.892-.04 4.193.01 2.662.1 4.324 1.74 4.434 4.401.05 1.251.01 2.501.01 3.762v77.631h36.346c-2.852-2.661-4.503-5.692-4.643-9.333-.13-3.502-.03-7.013-.03-10.735h-4.253c-5.494 0-10.988.01-16.472 0-5.014-.01-7.946-2.891-7.946-7.853-.01-13.906-.01-27.811 0-41.717.01-4.552 2.982-7.573 7.485-7.583 18.984-.02 37.968-.01 56.952-.01.41 0 .821.04 1.341.08v2.651H94.109c-4.013 0-5.504 1.481-5.504 5.492v40.817c0 3.841 1.55 5.382 5.444 5.382h20.485c0-2.471-.03-4.832.01-7.193.1-5.812 3.743-10.704 9.217-12.255 1.361-.38 2.812-.57 4.233-.57 13.91-.04 27.82-.04 41.73-.02 7.896.01 13.41 5.512 13.45 13.395.02 5.853-.08 11.695.03 17.548.09 4.521-1.001 8.503-4.954 12.024h16.292v2.731H51.197c-3.892 0-5.424-1.53-5.424-5.402v-77.701c0-4.112 1.461-5.562 5.625-5.562h2.892V90.687c1.02-.07 1.841-.12 2.872-.19V76.37h14.23v14.086l2.862.23c-.01 5.642-.01 11.224-.01 17.087zm74.795 45.688c-7.095 0-14.19-.01-21.296 0-6.174.01-10.467 4.292-10.487 10.434-.02 6.443-.02 12.876 0 19.318.01 6.163 4.303 10.464 10.457 10.474 14.071.01 28.151.01 42.221 0 6.165-.01 10.468-4.301 10.488-10.444.02-6.442.02-12.875 0-19.318-.02-6.172-4.293-10.454-10.458-10.474-6.975 0-13.95.01-20.925.01zm-100.554-1.36v39.025c0 2.301.27 2.571 2.572 2.581h26.5c2.301 0 2.572-.28 2.572-2.581v-78.041c0-2.301-.28-2.581-2.572-2.581h-26.32c-2.531 0-2.752.22-2.752 2.761v38.836zm8.717-58.714v14.276h14.19V93.388h-14.19zm2.872-14.326v11.405h8.516v-5.653c-.94-.07-1.811-.14-2.642-.21v-2.55c.94-.06 1.752-.1 2.582-.15v-2.842h-8.456z"
            fill="#FFDD00"
            stroke="#FFDD00"
            strokeWidth={2.5}
            strokeMiterlimit={10}
            strokeLinejoin="round"
            />
            <path
            d="M155.514 147.66h-2.612c.28-3.381.55-6.683.81-9.984.441-5.642 1.161-11.285 1.231-16.937.21-15.176-11.958-27.361-27.11-27.421-9.016-.03-18.023-.09-27.039.02-8.276.1-15.111 3.451-20.515 9.714-1.591 1.851-1.561 1.881-4.474 1.561 5.815-8.764 13.92-13.226 24.348-14.056V70.589h8.497V58.944c-1.221 0-2.502.02-3.783 0-2.722-.06-4.624-1.78-4.654-4.182-.03-2.39 1.882-4.211 4.574-4.261 15.081-.3 29.841 1.75 44.272 6.152.22.07.41.22.961.53-1.591 1.481-3.023 2.911-4.574 4.192-.4.33-1.2.31-1.791.24-6.865-.83-13.71-1.71-20.575-2.54-.871-.11-1.771-.01-2.812-.01v11.424h8.406v19.918c2.222.4 4.333.66 6.385 1.17 14.58 3.612 24.128 17.537 22.496 32.433-.82 7.523-1.291 15.087-1.931 22.63-.02.28-.06.57-.11 1.02zm-29.652-57.153V73.36h-22.787v17.147h22.787zm-8.586-20.048V59.044h-5.594V70.46h5.594z"
            fill="#FFDD00"
            stroke="#FFDD00"
            strokeWidth={2.5}
            strokeMiterlimit={10}
            />
            <path
            d="M171.125 92.558c.761.41 1.411.76 2.062 1.1-1.932 4.392-7.346 6.443-12.049 4.712-4.924-1.82-7.576-7.173-6.035-12.215 1.411-4.652 6.435-7.803 10.808-6.753.241 1.55.07 2.511-1.991 2.521-3.102.02-5.834 2.651-6.455 5.763-.6 3.03.891 6.212 3.643 7.733a7.22 7.22 0 008.586-1.21c.461-.45.851-.981 1.431-1.651z"
            fill="#FFDD00"
            stroke="#FFDD00"
            strokeMiterlimit={10}
            />
            <path
            d="M183.154 83.444c-.06 3.821-3.322 7.033-7.135 7.003-3.893-.03-7.155-3.402-7.045-7.263.12-3.832 3.422-6.993 7.225-6.903 3.833.07 7.015 3.351 6.955 7.163zm-2.732-.1c0-2.371-1.901-4.312-4.263-4.352a4.35 4.35 0 00-4.443 4.352 4.345 4.345 0 004.273 4.352c2.432.06 4.433-1.901 4.433-4.352zM197.474 70.539c-.05 3-2.641 5.572-5.644 5.572-3.062.01-5.714-2.681-5.664-5.732.05-3.072 2.782-5.683 5.824-5.573 3.013.11 5.534 2.752 5.484 5.733zm-5.604 2.84a2.924 2.924 0 002.872-3.02 2.91 2.91 0 00-2.882-2.822 2.917 2.917 0 00-2.962 2.932 2.909 2.909 0 002.972 2.91z"
            fill="#FFDD00"
            stroke="#FFDD00"
            strokeMiterlimit={10}
            />
            <path
            d="M131.586 183.985v-15.157c0-3.011.911-3.901 3.973-3.911h32.324c-1.261-1.901-2.792-2.691-4.604-2.701-9.607-.05-19.214-.07-28.821 0-3.162.02-5.514 2.441-5.574 5.612-.08 3.822-.06 7.633 0 11.455.02 1.87.751 3.461 2.702 4.702z"
            fill="#FFDD00"
            />
            <path
            d="M131.586 183.984c-1.951-1.25-2.672-2.831-2.702-4.691-.06-3.822-.08-7.634 0-11.455.07-3.171 2.412-5.592 5.574-5.612 9.607-.06 19.214-.04 28.821 0 1.812.01 3.333.8 4.604 2.701h-32.324c-3.062 0-3.963.89-3.973 3.911-.01 4.932 0 9.874 0 15.146z"
            fill="#FFDD00"
            stroke="#FFDD00"
            strokeWidth={2}
            strokeMiterlimit={10}
            strokeLinejoin="round"
            />
            <path
            d="M56.731 176.502h17.643v2.641H54.59v-54.092h19.814v2.581H56.732v48.87z"
            fill="#FFDD00"
            stroke="#FFDD00"
            strokeWidth={2.5}
            strokeMiterlimit={10}
            strokeLinejoin="round"
            />
            <path
            d="M180.422 57.053a2.392 2.392 0 100-4.783 2.392 2.392 0 000 4.783z"
            fill="#FFDD00"
            stroke="#606060"
            strokeWidth={0.25}
            strokeMiterlimit={10}
            />
            <path
            d="M146.257 57.673c.02-.12-.741-.55-1.231-.66-.59-.16-4.263-.87-4.873-.96-6.415-.97-9.688-1.17-16.152-1.781-6.125-.57-12.349-1.28-18.524-1.45-1.501-.04-2.502.84-1.811 1.55.43.44 1.481.75 2.241.74 12.64-.15 25.799 2.041 38.249 3.912.44.08 2.441-1.61 2.101-1.35z"
            fill="#000"
            />
        </svg>
    )
}

export default SvgIconCuidadoPersonalOn;